import { render } from "./ImageHeader.vue?vue&type=template&id=270d9764&scoped=true"
import script from "./ImageHeader.vue?vue&type=script&lang=js"
export * from "./ImageHeader.vue?vue&type=script&lang=js"

import "./ImageHeader.vue?vue&type=style&index=0&id=270d9764&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270d9764"]])

export default __exports__